const crmNewLineReplacer = (str?: string) =>
    str ? str.replace(/\r\n/g, '\n').replace(/\r\r/g, '\r\n').replace(/\r/g, '\n') : '';

export default crmNewLineReplacer;
